"use client";

import React from "react";

//Styles
import * as S from "./styles";
import { BoxCalcHeightProps } from "@/types";

const BoxCalcHeight: React.FC<BoxCalcHeightProps> = ({
  className,
  calcHeight,
  children,
}) => {
  return (
    <S.Box className={className} $height={calcHeight}>
      {children}
    </S.Box>
  );
};

export default BoxCalcHeight;
